import { Component, computed, inject, input, ChangeDetectionStrategy } from '@angular/core';
import { HisUploadFile } from '../../../../upload/model/his-upload-file';
import { HisBaseGlobalsService } from '../../../../core/service/base/his-base-globals.service';
type FileSetting = {
    label: string;
    helptext: string;
    required: boolean;
    readonly: boolean;
    value: HisUploadFile[];
    configKey: string;
    active: boolean;
    name: string;
}
@Component( {
    selector: 'his-file-job-setting',
    templateUrl: './his-file-job-setting.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false,
} )
export class HisFileJobSettingComponent {
    setting = input.required<FileSetting>();
    private baseGlobalService = inject( HisBaseGlobalsService );
    
    protected title = computed( () => {
        if (this.baseGlobalService.system.operationMode !== 'cust') {
            return '';
        }
        return this.setting().name;
    });
}
